export default "/biometrie-afghanistan/media/a7f095be8acee199f9f9f4338aaa6c7f~header-1600w.jpg";